<template>
  <myhead @next="next">{{ $route.query.title || $route.meta.title }}</myhead>
  <van-dropdown-menu class="myMenu ml8">
    <van-dropdown-item v-model="typeid" :options="typeList" />
  </van-dropdown-menu>
  <div class="ml14 mr14">
    <van-field left-icon="edit" maxlength="200" class="BGf5 Cccc pad15 radius8" v-model="content" type="textarea" rows="6" autosize
      placeholder="对我们网站的意见或建议，请在这里告诉我们。" show-word-limit />
      <div class="BGwhite pad12 mb10">
        <p class="b500">图片描述</p>
        <van-uploader v-model="fileList" multiple />
      </div>
    <div class="flex right mt15">
      <van-button round type="primary" class="width120px" @click="sub">提交反馈</van-button>
    </div>
  </div>
</template>

<script>
import ajax from "@/utils/request.js";
export default {
  name: "Home",
  data () {
    return {
      content: "",
      typeid: 0,
      fileList: [],//图片列表
      typeList: [
        { text: "请选择反馈类型", value: 0 },
        { text: "建议", value: 1 },
        { text: "意见", value: 2 },
        { text: "报错", value: 3 },
        { text: "申诉", value: 4 },
      ],
    };
  },
  watch: {},
  methods: {
    apply () { },
    sub () {
      if (this.typeid == 0) {
        return this.showToast("请选择反馈类型");
      }
      const data = {
          ...this.$route.query,
          typeid: this.typeid,
          content: this.content,
          feedback_imgs:[]
        }


      if (this.fileList.length > 0) {
          const uploadPromises = this.fileList.map((item) => {
            return ajax.post("api/dyuploadimg", { file: item.file })
              .then((res) => {
                data.feedback_imgs.push(res.data.url);
              });
          });

          // 使用 Promise.all 等待所有图片上传操作完成
          Promise.all(uploadPromises)
            .then(() => {
              this.ajax({
                method: "post",
                url: "users/feedback",
                data,
                myData: { showMsg: true },
              }).then(() => {
                this.$router.back();
              });
            })
            .catch((error) => {
              console.error("图片上传失败:", error);
              // 处理图片上传失败的情况
            });
        } else {
          this.ajax({
            method: "post",
            url: "users/feedback",
            data,
            myData: { showMsg: true },
          }).then(() => {
            this.$router.back();
          });
        }

      
    },
    next () {
      history.forward();
      // if(this.typeid==0){
      //   return this.showToast("请选择反馈类型")
      // }
      // this.ajax({method:"post",url:"users/feedback",data:{...this.$route.query,typeid:this.typeid,content:this.content},myData:{showMsg:true}}).then(()=>{
      //   this.$router.back();
      // })
    },
  },
  mounted () {
    // if (!this.$store.state.loginInfo.token) {
    //   this.$router.replace({ path: "/login", query: this.$route.query });
    // }
  },
};
</script>

<style>
</style>
